<div class="default-max-width centered margin--bottom-l margin--top-l default-padding">
  <h3 class="headline-second">{{ data.sliderTitle }}</h3>
  <swiper *ngIf="swiperOptions" class="margin--bottom-xl" [config]="swiperOptions">
    <ng-template swiperSlide *ngFor="let product of products$ | async">
      <app-product-item class="card-product card-product--no-mobile-config" [product]="product"> </app-product-item>
    </ng-template>
  </swiper>
</div>
